angular.module('workflow.app')
  .factory 'countryAliases', () ->
    return {
      'Aruba': ['Aruba (Kingdom of the Netherlands)']
      'Bosnia and Herzegovina': ['BIH']
      'British Virgin Islands': ['BVI']
      'Cape Verde': ['Cabo Verde']
      'Central African Republic': ['CAR']
      'China': ['PRC']
      'Curacao': ['Curacao (Kingdom of the Netherlands)']
      'Democratic Republic of the Congo': ['DRC', 'DR Congo', 'Congo-Kinshasa', 'RDC']
      'France': ['Réunion', 'French Guiana', 'French Polynesia']
      'Greece': ['Hellenic Republic']
      'Hong Kong': ['HK']
      'Iran': ['Islamic Republic of Iran']
      'Italy': ['Vatican', 'Holy See']
      'Ivory Coast': ['Côte d’Ivoire', 'Ivory Coast (Cote d\'Ivoire)']
      'Macau': ['Macao']
      'Micronesia, Federated States of': ['Micronesia', 'Micronesia, Federated states of', 'Federated States of Micronesia']
      'Myanmar': ['Burma']
      'Netherlands': ['Holland']
      'North Korea': ['DPRK']
      'Palestinian Territories': ['Palestine']
      'Puerto Rico': ['Puerto Rico (US)']
      'Republic of the Congo': ['Congo-Brazzaville', 'Congo Republic']
      'Russia': ['Russian Federation']
      'Saint Kitts and Nevis': ['St Kitts and Nevis']
      'Saint Lucia': ['St Lucia']
      'Sao Tome e Principe': ['Sao Tome and Principe']
      'Saudi Arabia': ['KSA']
      'South Africa': ['RSA']
      'St Vincent and the Grenadines': ['Saint Vincent and the Grenadines']
      'Taiwan': ['ROC']
      'Timor-Leste': ['East Timor']
      'Turks and Caicos': ['Turks and Caicos Islands (UK)']
      'UAE': ['United Arab Emirates', 'Emirates']
      'United Kingdom': ['Great Britain', 'UK', 'England', 'Wales', 'Scotland']
      'USA': ['United States', 'US', 'U.S.A.']
      'Vietnam': ['Viet Nam']
    }